export default __webpack_public_path__ + "static/media/k1_srnec_obecny-min.3b73dcf6.jpg";